<div class="main-container">
  <div class="flexbox">
    <div style="height: 15px">
      <!-- Placeholder for the close button -->
    </div>

    <div class="video-container-wrapper">
      <div class="video-container">
        <!-- Close button positioned relative to video container -->
        <div mat-dialog-close class="close-button-container">
          <span>Videó bezárása</span>
        </div>

        <iframe
          style="width: 100%; height: 100%;background-color:transparent; overflow:hidden;border-radius:30px;"
          [src]="data.videoUrl + '?autoplay=1' | safe: 'resourceUrl'"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</div>
